import React, { useState, useEffect, useContext } from "react";
import { useRouter } from "next/router";
import EventKit from "../../data/EventKit";
import InputComponent from "../../components/InputTextComponent";
import LayoutPrivate from "../../components/LayoutPrivate";
import AuthKit from "../../data/AuthKit";
import PageHead from "../../components/PageHead";
import { ChatContext } from "../../contexts/ChatContext";
import eventStatus from "../../data/enums/eventStatus";
import { GlobalPageDataContext } from "../../contexts/GlobalPageDataContext";
import hasContent from "../../util/hasContent";

export default function RegisterPage() {
  const [userEmail, setUserEmail] = useState("");
  const [eventData, setEventData] = useState(null);
  const [errorData, setErrorData] = useState(null);
  const [hasSubmitted, setHasSubmitted] = useState(false);

  const { hasUnreadMessages } = useContext(ChatContext);
  const { setGlobalPageData } = useContext(GlobalPageDataContext);

  const router = useRouter();
  const { event } = router.query;

  const eventKit = new EventKit();
  const authKit = new AuthKit();

  function handleOnSubmit(e) {
    setHasSubmitted(true);
    e.preventDefault();
    if (userEmail) {
      eventKit
        .registerUser(userEmail, event)
        .then((data) => {
          if (data.error) {
            setErrorData(true);
          } else {
            if (data.uuid && !data.otpTokenVerified) {
              router.push(
                `/${event}/authenticate?email=${data.eventUserEmail}`
              );
            } else if (data.uuid && data.otpTokenVerified) {
              router.push(`/${event}/check-in?uuid=${data.uuid}`);
            } else {
              setGlobalPageData((prevState) => ({
                ...prevState,
                registerSuccessRedirect: true,
              }));
              router.push(
                "/[event]/register-success",
                `/${event}/register-success`
              );
            }
          }
        })
        .catch((errors) => { });
    }
  }

  function goToRegisterOktaPage() {
    const data = {
      client_id: eventData?.authenticationService?.clientId,
      redirect_uri: `${process.env.NEXT_PUBLIC_ROOT_URL}/api/v1/events/events/okta-register/`,
      scope: "openid email profile",
      state: event,
      nonce: "SampleNonce",
      response_type: "code",
      response_mode: "query",
    };
    const queryString = new URLSearchParams(data);
    const url = `https://${eventData?.authenticationService?.url
      }/oauth2/v1/authorize?${queryString.toString()}`;
    router.push(url);
  }

  function registerWithMicrosoft() {
    const data = {
      client_id: eventData?.authenticationService?.clientId,
      response_type: "code",
      redirect_uri: `${process.env.NEXT_PUBLIC_ROOT_URL}/api/v1/events/events/microsoft-register/`,
      response_mode: "query",
      scope: eventData?.authenticationService.scope || "openid email profile offline_access User.Read User.Read.All User.ReadBasic.All",
      state: event,
    };
    const queryString = new URLSearchParams(data);
    const tenant = eventData?.authenticationService.microsoftTenantId || 'common'
    const url = `https://${eventData?.authenticationService?.url
      }/${tenant}/oauth2/v2.0/authorize?${queryString.toString()}`;
    router.push(url);
  }

  useEffect(() => {
    authKit.deleteToken();
  }, []);

  useEffect(() => {
    if (event) {
      eventKit.getEventDetail(event).then((data) => {
        setEventData(data);
        if (!eventKit.shouldRender(data)) {
          router.push(`/${event}/idle`);
        }
      }).catch((errors) => { });
    }
  }, [event]);

  function renderActiveEvent() {
    return (
      <>
        {eventData && (
          <PageHead
            eventTitle={eventData.title}
            suffix="Register"
            hasUnreadMessages={hasUnreadMessages}
          />
        )}
        <>
          {eventData && (
            <>
              <div
                className="view-image-custom d-flex align-items-center justify-content-center"
                style={{
                  backgroundImage:
                    eventData.backgroundImageLarge &&
                    `url(${eventData.backgroundImageLarge
                      ? eventData.backgroundImageLarge
                      : ""
                    })`,
                }}
                data-bg={
                  eventData.backgroundImageLarge
                    ? eventData.backgroundImageLarge
                    : "/assets/bgNotSet.png"
                }
              >
                <form onSubmit={handleOnSubmit}>
                  <div className="sign-in register-wrapper">
                    <img src={eventData.logotype} className="sing-in__logo" />
                    {errorData && (
                      <>
                        {hasContent(eventData.registerErrorText) && (
                          <div
                            className="register-error-text"
                            dangerouslySetInnerHTML={{
                              __html: eventData && eventData.registerErrorText,
                            }}
                          ></div>
                        )}
                        <button
                          className="gform_button"
                          onClick={(e) => setErrorData(null)}
                        >
                          Go Back
                        </button>
                      </>
                    )}

                    {!errorData && (
                      <>
                        {/* <div className="gform_subheading d-flex justify-content-center text-center">
                          Enter the email you are registered with to receive your login code
                        </div> */}
                        {eventData.hasEmailRegister && (
                          <div>
                            <div className="gform_heading"></div>
                            <div className="gform_body">
                              <label className="gfield_label">Email</label>
                              <div>
                                <InputComponent
                                  type="email"
                                  placeholder="Your email address"
                                  onChange={(e) => setUserEmail(e.target.value)}
                                  value={userEmail}
                                />
                              </div>
                              {hasSubmitted && !userEmail && (
                                <p className="alert-error error-text-message text-danger mb-3 mt-n3">
                                  {/* <small class="small"> */}
                                  Please fill out this field
                                  {/* </small> */}
                                </p>
                              )}

                              <button className="gform_button" type="submit">
                                Send
                              </button>
                            </div>
                          </div>
                        )}

                        {eventData.hasOktaRegister && (
                          <div className="sign-in__sso">
                            <a onClick={goToRegisterOktaPage}>
                              Sign in using SSO
                            </a>
                          </div>
                        )}

                        {eventData.hasMicrosoftAuthentication && (
                          <div className="sign-in__sso">
                            <a onClick={registerWithMicrosoft}>
                              Sign in with SSO
                            </a>
                          </div>
                        )}

                        {hasContent(eventData.termsOfServiceText) && (
                          <p
                            className="sign-in__leagal"
                            dangerouslySetInnerHTML={{
                              __html: eventData.termsOfServiceText,
                            }}
                          ></p>
                        )}
                      </>
                    )}
                  </div>
                </form>
              </div>
            </>
          )}
        </>
      </>
    );
  }

  return (
    <LayoutPrivate hasAnnouncement={false}>
      {eventData &&
        eventData.status === eventStatus.ACTIVE &&
        renderActiveEvent()}
    </LayoutPrivate>
  );
}
